module.exports = __webpack_public_path__ + "img/zhongxin.1bdbe9f5.png";